module.exports = "/cyber/_next/static/images/other-prize-7f8a5c96b2e80ed03b5838d8406a3942.png";